import real from 'compact-encoding/index.js'

/**
 * compact-encoding compatibility shim.
 *
 * Version 2 of compact-encoding let `c.buffer` encode `null`: it wrote a zero
 * length and decoded that back to null. Version 3 split that behaviour out
 * into `c.optionalBuffer` and made `c.buffer` throw on null.
 *
 * Autobase was written against the 2.x contract and still depends on it. An
 * acknowledgement node is `{ value: null }`, and the linearizer tells acks
 * apart from empty blocks by exactly that null. Autobase 6.5.13 also never
 * declares compact-encoding as a dependency, so a bundler hands it whichever
 * copy the rest of the tree hoisted — 3.x — and the first background ack after
 * a second writer joins takes the whole room down with
 * "Cannot read properties of null (reading 'length')".
 *
 * On Node this is fixed by giving Autobase its own nested 2.x copy (see
 * scripts/fix-autobase-encoding.mjs). A bundler cannot express per-package
 * resolution, so the browser and Bare builds alias `compact-encoding` to this
 * file instead.
 *
 * The wire format is untouched: 3.x `optionalBuffer` is character for
 * character what 2.x `buffer` was. Only the JavaScript value that a zero
 * length decodes back to differs.
 *
 * Every key is re-exported by name as well as on the default object, because
 * consumers reach this module through three different interop paths: ESM
 * default imports in Pine's own source, CommonJS requires inside the Hypercore
 * packages, and esbuild namespace objects during dependency pre-bundling.
 *
 * Generated by scripts/gen-encoding-shim.mjs — do not edit by hand.
 */

export const buffer = real.optionalBuffer

export const binary = {
  ...buffer,
  preencode (state, b) {
    if (typeof b === 'string') real.utf8.preencode(state, b)
    else buffer.preencode(state, b)
  },
  encode (state, b) {
    if (typeof b === 'string') real.utf8.encode(state, b)
    else buffer.encode(state, b)
  }
}

export const any = real.any
export const array = real.array
export const arraybuffer = real.arraybuffer
export const ascii = real.ascii
export const base64 = real.base64
export const bigint = real.bigint
export const bigint64 = real.bigint64
export const bigint64array = real.bigint64array
export const biguint = real.biguint
export const biguint64 = real.biguint64
export const biguint64array = real.biguint64array
export const bool = real.bool
export const date = real.date
export const decode = real.decode
export const encode = real.encode
export const fixed = real.fixed
export const fixed32 = real.fixed32
export const fixed64 = real.fixed64
export const float32 = real.float32
export const float32array = real.float32array
export const float64 = real.float64
export const float64array = real.float64array
export const frame = real.frame
export const from = real.from
export const hex = real.hex
export const int = real.int
export const int16 = real.int16
export const int16array = real.int16array
export const int24 = real.int24
export const int32 = real.int32
export const int32array = real.int32array
export const int40 = real.int40
export const int48 = real.int48
export const int56 = real.int56
export const int64 = real.int64
export const int8 = real.int8
export const int8array = real.int8array
export const ip = real.ip
export const ipAddress = real.ipAddress
export const ipv4 = real.ipv4
export const ipv4Address = real.ipv4Address
export const ipv6 = real.ipv6
export const ipv6Address = real.ipv6Address
export const json = real.json
export const lexint = real.lexint
export const ndjson = real.ndjson
export const none = real.none
export const optionalBuffer = real.optionalBuffer
export const port = real.port
export const raw = real.raw
export const record = real.record
export const state = real.state
export const string = real.string
export const stringRecord = real.stringRecord
export const ucs2 = real.ucs2
export const uint = real.uint
export const uint16 = real.uint16
export const uint16array = real.uint16array
export const uint24 = real.uint24
export const uint32 = real.uint32
export const uint32array = real.uint32array
export const uint32be = real.uint32be
export const uint40 = real.uint40
export const uint48 = real.uint48
export const uint56 = real.uint56
export const uint64 = real.uint64
export const uint64be = real.uint64be
export const uint8 = real.uint8
export const uint8array = real.uint8array
export const utf16le = real.utf16le
export const utf8 = real.utf8

const patched = { ...real, buffer, binary }

export default patched
